<script>
  import SvgComment from "$assets/svg/ic_comment.svg?src";
  import SvgMusicNote from "$assets/svg/ic_music_note.svg?src";
  import SvgProfileAdd from "$assets/svg/ic_profile_add.svg?src";
  import SvgShare from "$assets/svg/ic_share.svg?src";
  import LikeSvg from "@/assets/svg-comp/LikeSvg.svelte";
  import SvgWrapper from "@/components/atoms/SvgWrapper.svelte";
  import constants from "@/constants";
  import { INSTALL_REFERRER } from "@/constants/constants";
  import trackEvents from "@/events";
  import EVENTS from "@/events/events";
  import landingPageStore from "@/stores/landingPageStore";
  import {
    _normalizeNumber,
    resetIfDeletedPic,
    appendWidthParam,
  } from "@/utils";
  import * as css from "@/utils/css";
  import { getSongNameFromPost } from "@/utils/helpers/utils";
  import * as PropTypes from "prop-types";

  import { onMount } from "svelte";
  import PopupOverlay from "../organisms/PopupOverlay.svelte";
  import InstallNudgeContent from "./InstallNudgeContent.svelte";
  import { getInstallImage } from "@/utils/helpers/utils";

  const { DEFAULT_USER_PIC, DEFAULT_SRC } = constants;
  const defaultPic = appendWidthParam(DEFAULT_USER_PIC, "60");
  const { checkPropTypes, func, object, string } = PropTypes;

  export let item,
    videoSrc,
    handleShowComment,
    toggleLikeButton = () => {},
    index = 0,
    toggleInstallBanner = () => {},
    isVideoPaused,
    playVideo = () => {};

  const propTypes = {
    item: object,
    videoSrc: string,
    handleShowComment: func,
    toggleInstallBanner: func,
    toggleLikeButton: func,
  };

  onMount(() => {
    toggleInstallBanner(true);
    checkPropTypes(propTypes, $$props, "prop", "VideoOverlay");
  });

  let showSharePopup = false;
  let hideSeeMore = false;
  const maxWordsInCaption = 6;
  const maxWordsInSongName = 6;
  const songName = getSongNameFromPost(item);

  $: isSeeMoreRequired = item.c && item.c.split(" ").length > maxWordsInCaption;

  $: isRotateRequired =
    songName && songName.split(" ").length > maxWordsInSongName;

  $: sliceWords =
    item.c && item.c.split(" ").slice(0, maxWordsInCaption).join(" ");

  $: caption = isSeeMoreRequired ? sliceWords : item.c;

  const handleSeeMore = (e) => {
    e.stopPropagation();
    caption = item.c;
    hideSeeMore = true;
  };
  const handleSeeLess = (e) => {
    e.stopPropagation();
    caption = sliceWords || "";
    hideSeeMore = false;
  };

  const onShareClick = () => {
    trackEvents(EVENTS.SHARE_BUTTON, {
      postId: item.i,
      videoUrl: videoSrc,
    });
    showSharePopup = true;
  };

  const onDownloadCtaClick = () => {
    trackEvents(EVENTS.PWA_SHARE_NUDGE_ACTION, {
      postId: item.i,
      videoUrl: videoSrc,
      isDownloadCtaClick: true,
    });
  };

  const hideSharePopup = () => {
    showSharePopup = false;
    playVideo(true, true);
  };

  const handleHandleClick = async () => {
    trackEvents("HandleTapped", {
      postId: item.i,
      videoUrl: videoSrc,
    });
  };
  const handleLikeClick = () => {
    trackEvents("LikeButton", {
      postId: item.i,
      videoUrl: videoSrc,
    });
    toggleLikeButton(index);
  };

  const handleCommentClick = () => {
    trackEvents("CommentButton", {
      postId: item.i,
      videoUrl: videoSrc,
    });

    landingPageStore.updateState({
      showHardNudge: true,
      selectedItem: {
        title: "Comment now!",
        referer: INSTALL_REFERRER.COMMENT_NUDGE,
        label: "comment",
      },
    });
  };

  const onAudioLableClick = () =>
    trackEvents("AudioLabel", {
      postId: item.i,
      videoUrl: videoSrc,
    });
</script>

{#if item.isMuted && !isVideoPaused}
  <div class="flex items-center h-screen justify-center">
    <div class="bg-black p-xss rounded-[10px] opacity-50 text-white">
      This music isn't available in your region
    </div>
  </div>
{/if}

<div
  class={`${css.fullCover} z-[1] bg-transparent flex items-center justify-end flex-col text-white`}
>
  <div class="w-full flex items-end justify-between bg-overlay">
    <div class={`mt-4 ml-4 overflow-hidden mb-[106px]`}>
      <div
        class="flex items-center text-smd font-bold leading-md break-words mb-xss"
      >
        <a
          data-testid="author-name"
          data-value={item.ath?.h}
          href={`/@${item.ath?.h}?referrer=web`}
        >
          @{item.ath?.h}
        </a>
        {#if item.ath?.badgeUrl}
          <img class="h-md w-md ml-xxs" src={item.ath.badgeUrl} alt="Badge" />
        {/if}
      </div>

      {#if caption}
        {#if isSeeMoreRequired}
          <div>
            <span class="break-words text-grey5">{caption}</span>
            <span
              on:mousedown|stopPropagation
              on:mouseup={hideSeeMore ? handleSeeLess : handleSeeMore}
              class={`font-semibold`}
              >{hideSeeMore ? "...see less" : "...see more"}</span
            >
          </div>
        {:else}
          <div class="break-words">{caption}</div>
        {/if}
      {/if}

      {#if item.audioMeta && !item.isMuted}
        <a
          data-testid="audio-item"
          data-value={item.audioMeta.audioId}
          href={`/music/${item.audioMeta.audioId}?referrer=web`}
          class="flex items-center justify-start"
        >
          <SvgWrapper
            className="inline-block w-mmd h-mmd mr-xs my-xs"
            svg={SvgMusicNote}
          />
          <span class="w-25xl overflow-hidden relative">
            <p
              class={`inline-block w-screen m-0 ${
                isRotateRequired ? "scroll-left" : ""
              }`}
            >
              {songName}
            </p>
          </span>
        </a>
      {/if}
    </div>

    <div class={`${css.allCenteredChild} flex-col mx-1 mt-1 mb-[106px]`}>
      <div
        class="my-sm relative"
        data-testid="author-profile-pic"
        data-value={item.ath?.h}
      >
        <a
          href={`/@${item.ath?.h}?referrer=web`}
          on:click={handleHandleClick}
          class="flex w-2xl"
        >
          <img
            src={DEFAULT_SRC}
            data-src={resetIfDeletedPic(item.ath?.tu) || defaultPic}
            class="rounded-[50%] h-2xl w-2xl bg-cover bg-light-grey bd-white object-cover lazyload"
            alt={item.ath?.n}
            width="48"
            height="48"
          />
        </a>
        <SvgWrapper
          className="absolute left-1/2 -translate-x-1/2 bottom-nxms h-mdd w-mdd bg-white rounded-[50%]"
          svg={SvgProfileAdd}
        />
      </div>

      <div
        on:click={handleLikeClick}
        on:mouseup|stopPropagation
        on:mousedown|stopPropagation
        class={`py-sm ${css.allCenteredChild} flex-col`}
        data-testid="like-button"
      >
        <div class={"h-xxl w-xxl"}>
          <LikeSvg fill={+item.pl ? "red" : "white"} />
        </div>
        <div class="text-sm font-bold">
          {parseInt(item.lc) ? _normalizeNumber(item.lc) : "Like"}
        </div>
      </div>

      <div
        on:click={handleCommentClick}
        class={`py-sm ${css.allCenteredChild} flex-col`}
        data-testid="comment-button"
      >
        <SvgWrapper className={"h-xxl w-xxl"} svg={SvgComment} />
        <div class="text-sm font-bold">
          {item.c2 ? _normalizeNumber(item.c2) : "Comment"}
        </div>
      </div>

      <div
        on:click={onShareClick}
        class={`py-sm ${css.allCenteredChild} flex-col`}
        data-testid="share-button"
      >
        <SvgWrapper className={"h-xxl w-xxl"} svg={SvgShare} />
        <div class="text-sm font-bold">
          {Number(item.us) ? _normalizeNumber(item.us) : "Share"}
        </div>
      </div>

      <div data-testid="audio-label">
        {#if item.audioMeta && !item.isMuted}
          <div
            on:click={onAudioLableClick}
            class="py-sm flex"
            data-testid="audio-svg"
            data-value={item.audioMeta.audioId}
          >
            <a href={`/music/${item.audioMeta.audioId}?referrer=web`}>
              <div class={`audioLabel rounded-[50%]`}>
                <img
                  class="rounded-[50%] h-xxml w-xxml bg-cover bg-light-grey object-cover lazyload bd-audio-original rotate"
                  src={DEFAULT_SRC}
                  data-src={resetIfDeletedPic(item.audioMeta.thumbUrl) ||
                    defaultPic}
                  alt={item.ath?.n}
                  width="44"
                  height="44"
                />
              </div>
            </a>
          </div>
        {/if}
      </div>
    </div>
  </div>
</div>

{#if showSharePopup}
  <PopupOverlay
    show={showSharePopup}
    onClose={hideSharePopup}
    closeOnOutsideClick={true}
  >
    <InstallNudgeContent
      isHardNudge={false}
      trackDownloadClick={onDownloadCtaClick}
      isShareSheet={true}
      {getInstallImage}
      onClose={hideSharePopup}
    />
  </PopupOverlay>
{/if}

<style>
  .audioLabel {
    box-shadow: 0px 4px 4px 0px #00000040;
  }
</style>
